"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = void 0;
var ui_env_1 = require("@dcl/ui-env");
var dev_json_1 = __importDefault(require("./env/dev.json"));
var stg_json_1 = __importDefault(require("./env/stg.json"));
var prod_json_1 = __importDefault(require("./env/prod.json"));
exports.config = (0, ui_env_1.createConfig)((_a = {},
    _a[ui_env_1.Env.DEVELOPMENT] = dev_json_1.default,
    _a[ui_env_1.Env.STAGING] = stg_json_1.default,
    _a[ui_env_1.Env.PRODUCTION] = prod_json_1.default,
    _a));
